// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import About from '../views/AboutPage.vue';
import Contact from '../views/ContactPage.vue';
import Treatments from '../views/TreatmentsPage.vue';
import Pricing from '../views/PricingPage.vue';
import Booking from '../views/BookingPage.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/esittely',
        name: 'Esittely',
        component: About
    },
    {
        path: '/otayhteytta',
        name: 'Otayhteytta',
        component: Contact
    },
    {
        path: '/hoidot',
        name: 'Hoidot',
        component: Treatments
    },
    {
        path: '/hinnasto',
        name: 'Hinnasto',
        component: Pricing
    },
    {
        path: '/varaa',
        name: 'Varaa',
        component: Booking
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 }
    },
});

export default router;
